// Internal Imports
import { PARSER } from "../configuration";

export const generateColumDef = (readOnlyData, payload) => {
  PARSER.columnParser.forEach(method => {
    method.forEach(func => {
      func.method({ readOnlyData, payload });
    });
  });
};

// ======================================================================

export const generateRowData = (readOnlyData, payload) => {
  PARSER.rowParser.forEach(method => {
    method.forEach(func => {
      if (!payload.break) {
        func.method({ readOnlyData, payload });
      }
    });
  });
};

// ======================================================================

export const generateDTRowsFromProductCatalogs = async (
  readOnlyData,
  payload,
) => {
  try {
    // eslint-disable-next-line no-restricted-syntax
    for (const parser of PARSER.addProductsToDealTableParser) {
      // eslint-disable-next-line no-restricted-syntax
      for (const func of parser) {
        // eslint-disable-next-line no-await-in-loop
        await func.method({
          readOnlyData,
          payload,
        });
      }
    }
  } catch (err) {
    console.error("Parser => generateDTRowsFromProductCatalogs", err);
  }
};

// ======================================================================

export const handleAddingProductsToDealTable = async (
  readOnlyData,
  payload,
) => {
  try {
    // eslint-disable-next-line no-restricted-syntax
    for (const parser of PARSER.addProductsToDealTableParserV2) {
      // eslint-disable-next-line no-restricted-syntax
      for (const func of parser) {
        // eslint-disable-next-line no-await-in-loop
        await func.method({
          readOnlyData,
          payload,
        });
      }
    }
  } catch (err) {
    console.error("Parser => handleAddingProductsToDealTable", err);
    throw err;
  }
};

// ======================================================================

export const handleNetPriceRounding = (readOnlyData, payload) => {
  PARSER.netPriceRoundingParser.forEach(parser => {
    parser.forEach(func => {
      func.method({
        readOnlyData,
        payload,
      });
    });
  });
};

// ======================================================================

export const handleRippleEffectOnCellChange = async (readOnlyData, payload) => {
  //* When a Cell in Grid Changes, Based On The Column Type a Ripple Effect Happens

  try {
    // eslint-disable-next-line no-restricted-syntax
    for (const parser of PARSER.onCellChangeParser) {
      // eslint-disable-next-line no-restricted-syntax
      for (const func of parser) {
        // eslint-disable-next-line no-await-in-loop
        await func.method({
          readOnlyData,
          payload,
        });
      }
    }
  } catch (err) {
    console.error("Parser => handleRippleEffectOnCellChange", err);
  }
};
